<template>
    <div class="publicViewClass ">
         <div class="show_container">
             <div class="staff_manage_head">
                       <div class="public-btn-div flex align-cen" >
      <div class="public-add" @click="addTopic">
            新增试题
      </div>
      <div style="height:16px;width:2px;background:#e6e6e6;margin:0 6px 0 8px;"></div>
      <div class="public-de flex align-cen" @click="deletTopic(multipleSelection)">
        <span class="icon-al-delete"></span>
        <p>删除试题</p>
      </div>
       <div class="public-de flex align-cen" @click="moveTopic(multipleSelection)">
        <span class="icon-al-switch"></span>
        <p>移动到分类</p>
      </div>
       <div class="public-de flex align-cen" @click="openImport">
        <span class="icon-al-file-plus"></span>
        <p>导入试题</p>
      </div>
       <div class="public-de flex align-cen" @click="openRepeat">
        <span class="icon-al-search"></span>
        <p>题库查重</p>
      </div>
    </div>
     <div class="p-tit-c">
        <div class="businessList-filter">
              <div class="businessList-filter-list flex align-cen">
                  <div class="fl-le flex align-cen">
          <div class="label">题目标题：</div>
          <div class="el-select1">
            <el-input placeholder="请输入题目标题" v-model="search" clearable> </el-input>
          </div>
         </div>
            <div class="fl-rt flex align-cen">
          <div class="label">题目ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入题目ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
           <div class="fl-rt flex align-cen">
          <div class="label">题目创建人：</div>
          <div class="el-select1">
          <el-input placeholder="请输入题目创建人" v-model="search2" clearable> </el-input>
          </div>
         </div>
            </div>
             <div class="businessList-filter-list flex align-cen">
                <div class="label">题目标签：</div>
                    <div
                    style="color: red; padding-right: 20px; cursor: pointer"
                    @click="allradio(0)"
                    >
                    不限
                    </div>
                      <el-checkbox-group v-model="checkList" @change="classSelect">
                        <el-checkbox label="常识"></el-checkbox>
                        <el-checkbox label="较难"></el-checkbox>
                        <el-checkbox label="难"></el-checkbox>
                        <el-checkbox label="很难"></el-checkbox>
                    </el-checkbox-group>
             </div>
              <div class="businessList-filter-list flex align-cen">
                 <div class="label">题型：</div>
                    <div
                    style="color: red; padding-right: 20px; cursor: pointer"
                     @click="allradio(1)"
                    >
                    不限
                    </div>
                       <el-checkbox-group v-model="checkList1" @change="classSelect">
                        <el-checkbox label="1">单选题</el-checkbox>
                        <el-checkbox label="2">多选题</el-checkbox>
                        <el-checkbox label="3">判断题</el-checkbox>
                        <el-checkbox label="4">填空题</el-checkbox>
                          <el-checkbox label="5">问答题</el-checkbox>
                        <el-checkbox label="6">不定项选择题</el-checkbox>
                        <el-checkbox label="7">排序题</el-checkbox>
                        <el-checkbox label="9">完形填空题</el-checkbox>
                    </el-checkbox-group>
              </div>
              <div class="businessList-filter-list flex align-cen">
                  <div class="fl-le flex align-cen">
                      <div class="label">题目分类：</div>
                        <el-select
            v-model="value1"
            clearable
            placeholder="请选择"
            @change="classSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
                  </div>
              </div>
              <div class="businessList-filter-list flex align-cen">
        <div class="label">创建时间：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
           @change="classSelect"
        >
        </el-date-picker>
      </div>
    <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
         <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)">
          导出
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件
        </div>
      </div>
        </div>
     </div>
             </div>
                <div class="staff_manage_center">
                 <div class="businessList-container-table">
                <el-table
                ref="multipleTable"
                :data="list"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                 :row-key="getRowKeyOfTarget"
                 @selection-change="handleSelectionChange"
                >
                <el-table-column type="selection" width="55" reserve-selection align="center" fixed="left"> </el-table-column>
          <el-table-column prop="id" label="题目id" align="center" width="200">
          </el-table-column>
          <el-table-column  label="题目标题" align="center" width="400">
            <template slot-scope="scope">
              <div class="flex align-cen justify-content-cen"> 
                   <div  v-html="scope.row.title" class="publictitline2" :class="scope.row.type == 9 ? 'clozeClass' : ''"></div>
                <AudioTem :audioSrc="scope.row.audio" v-if="scope.row.audio"></AudioTem>
                </div> 
              
            </template>
          </el-table-column>
           <el-table-column prop="title" label="题型" align="center">
            <template slot-scope="scope">
              <p>{{$util.getTopicType(scope.row.type)}}</p>
            </template>
          </el-table-column>
           <el-table-column prop="createBy" label="创建人" align="center">
          </el-table-column>
           <el-table-column prop="classifyName" label="分类" align="center">
          </el-table-column>
           <el-table-column prop="score" label="分数" align="center">
          </el-table-column>
             <el-table-column prop="paperNum" label="被试卷收录" align="center">
               <template slot-scope="scope">
              <div style="color:red;cursor: pointer;" @click="openPaper(scope.row)">{{scope.row.paperNum}}</div> 
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="200"
            >
             <template slot-scope="scope">
                <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openPreview(scope.row,scope.$index)">预览题目</el-button>
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="addTopic(scope.row)">编辑试题</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="openTopicCount(scope.row)">统计分析</el-button> 
            </template>
          </el-table-column>
                 </el-table>
                   <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                 </div>
                </div>
         </div>
                          <!-- 移动到分类弹窗 -->
      <el-dialog
  title="移动到分类"
  :visible.sync="centerDialogVisible"
  width="30%"
  :append-to-body="true"
  center>
   <div class="forminfo"
    v-loading="loading"
      element-loading-text="正在移动中..."
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
   >
       <div class="seltmodel">
                       <el-select
            v-model="classifyId"
            clearable
            placeholder="请选择"
            style="width:100%"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-if="item.id!=2"
            >
            </el-option>
          </el-select>
              </div>
                <div class="btn" @click="onsubmit">确定</div>
   </div>
      </el-dialog>
           <!-- 打开被试卷收录弹窗-->
      <el-dialog
      title="被试卷收录"
  :visible.sync="centerDialogVisible1"
  width="60%"
  :append-to-body="true"
  center
  custom-class="publicDialogClass"
  @close="centerDialogVisible1 = false"
  v-if="centerDialogVisible1"
      >
      <div class="forminfo">
        <paperTemplate
             :topicID="PropId"
            :editType="'paper'"
            ref="topicTemplate1"
            ></paperTemplate>
            <div class="authbtn flex align-cen">
        <el-button plain @click="centerDialogVisible1 = false"> 取消</el-button>
    </div>
      </div>
      </el-dialog>
    </div>
</template>
<script>
import { getQuestionClass,questionList,getEnQuestion,enmoveQuestion} from "@/api/enterprise/index"; // 题目分类、题目列表、删除题目、移动到分类
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import exportExcel from '../../utils/exportExcel.js' //导出数据公共方法
import debounce from '../../utils/debounce.js' //防抖
import mycomponents from "../../utils/compoments.js"
import paperTemplate from "@/weteacheManage/enTestPaper/index.vue"; //将试卷列表页面作为组件使用
export default {
     components:{
      paginaTion,
      paperTemplate,
      AudioTem: mycomponents.components.PublicAudio
    },
    data () {
        return {
          PropId:'',
          centerDialogVisible1:false,
            businessInfo:{},
             classifyId:'',
          loading:false,
          centerDialogVisible:false,
          multipleSelection:[],
            search:'',
            search1:'',
            search2:'',
            checkList: [],
            checkList1:[],
            options:[],
            value1:'',
            value2:'',
             start_time:'',
            end_time:'',
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[],
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    created() {
         this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getClass()
        this.gethisList()
    },
    methods: {
      // 打开被试卷收录弹窗
      openPaper(data){
        if(data.paperNum == 0) return
            this.PropId = data.id
            this.centerDialogVisible1 = true
      },
      // 不限
      allradio(type){
        type == 0 ? this.checkList = [] : this.checkList1 = []
        this.currentPage = 1
        this.gethisList()
      },
      // 导出
      exportExcel(val){
        if(val.length !=0){
           var parser = new DOMParser();  
          let keyLisst = [] 
           for(let item in val){
            let  doc = parser.parseFromString(val[item].title, "text/html");  
            let p = doc.body.firstChild;  
            if(val[item].type == 9){
              var children = doc.body.children; 
              var arrayTit = []
              for (var i = 0; i < children.length; i++) {  
                arrayTit.push(children[i].innerText)
              }
              var stringWithCommaSeparator = arrayTit.join(','); 
            }
             keyLisst.push( {
              '题目ID':val[item].id, 
              '题目标题':val[item].type == 9 ? stringWithCommaSeparator : p.textContent, 
              '题型':this.$util.getTopicType(val[item].type),
              '创建人':val[item].createBy,
              '分类':val[item].classifyName, 
              '分数':val[item].score,
              '被试卷收录': val[item].paperNum,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
        }
        else{
          this.$util.Notifi('请选择导出试题','error','fa-exclamation-circle')
        }
      },
        // 重置
        reset(){
          this.search1=""
          this.search=""
          this.search2=""
          this.checkList=[]
          this.checkList1=[]
          this.value1=""
           this.value2=""
          this.start_time=""
          this.end_time=""
          this.classifyId=""
          this.currentPage=1
          this.gethisList()
        },
        // 搜索
        classSelect(){
           if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
          this.currentPage = 1
          this.gethisList()
        },
       // 打开统计
        openTopicCount(data){
          this.$router.push({name:'questionCount',query:{id:data.id,type:data.type}})
        },
        // 打开预览
       openPreview(data,index){
        this.$router.push({name:'previewQuestion',query:{id:data.id,index:index,length:this.totalCount,current:this.currentPage}})
       },
         // 移动到分类
      moveTopic(val){
        if(!val.length){
           this.$util.Notifi('请选择移动分类的题目','error','fa-exclamation-circle')
        }else if(val.some(item => item.classifyId == 2)){
          this.$util.Notifi('包含平台端题目，请重新选择','error','fa-exclamation-circle')
        }
        else{
          this.centerDialogVisible = true 
        }
      },
            // 确定移动到分类
      onsubmit(){
        if(!this.classifyId) return this.$util.Notifi('请选择分类','error','fa-exclamation-circle')
        let ids = []
         this.multipleSelection.forEach(t => {
            ids.push(t.id)
          });
        let params = {
        classifyId:this.classifyId,
        ids:ids,
        businessId:this.businessInfo.id
        }
        //防抖提交
                debounce(() => {
                    this.commentBness(params)
                }, 500)
      },
       commentBness(params){
        this.loading = true
           enmoveQuestion(params,'enterprise')
            .then(res => {
              this.loading = false
              if(res.code == 0){
                this.$util.Notifi('移动成功','success','fa-check')
                   this.multipleSelection = []
                  this.$refs.multipleTable.clearSelection();
                  this.gethisList()
                      setTimeout(() => {
                  this.centerDialogVisible = false
                  }, 100);
              }else{
              this.$util.Notifi(res.meg,'error','fa-exclamation-circle')
              }
          })
          .catch(err => {
            this.loading = false
          })
       },
        // 打开去重页面
      openRepeat(){
        this.$router.push('/teacheManage/questionRepeaTopic')
      },
       // 打开导入页面
      openImport(){
        this.$router.push('/teacheManage/questionImport')
      },
           // 删除题目（可多选）
      deletTopic(val){
        let chek = []
        if(!val.length){
          this.$util.Notifi('请选择删除题目','error','fa-exclamation-circle')
        }else if(val.some(item => item.classifyId == 2)){
          this.$util.Notifi('包含平台端题目，请重新选择','error','fa-exclamation-circle')
        }
        else{
          val.forEach(t => {
            chek.push(t.id)
          });
         chek = chek.join(",")
         this.$confirm('您确定要删除该试题吗？删除后会影响添加了该题的试卷，请您谨慎操作！', '删除试题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            getEnQuestion({
              id:chek,
              businessId:this.businessInfo.id
              },'delete','enterprise')
                .then(res => {
                if(res.code == 0){
                   this.$util.Notifi('删除成功','success','fa-check')
                 this.multipleSelection = []
                  this.$refs.multipleTable.clearSelection();
                   this.gethisList()
                }else{
                   this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
                }
              })
              .catch(err => {
              })
        })
        }
      },
      // 添加试题
      // 新增题目
        addTopic(data){
          if(data.classifyId == 2){
             return this.$util.Notifi('平台端题目不允许修改','error','fa-exclamation-circle')
          }
         
            data.id ? this.$router.push({name:'addQuestion',query:{id:data.id}}) : this.$router.push({name:'addQuestion',query:{type:1}})
        },
                    // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList()
      },
        // 获取题目列表
        gethisList(){
           let params = {
                businessId:this.businessInfo.id,
                id:this.search1,
                title:this.search,
                createBy:this.search2,
                tags:this.checkList.join(','),
                types:this.checkList1.join(','),
                classifyId:this.value1,
                createTimeStart:this.start_time,
                createTimeEnd:this.end_time,
                size:this.PageSize,
                current:this.currentPage,
            }
        questionList(params,'enterprise')
          .then(res => {
            this.list = res.data.records
            this.totalCount = res.data.total
          })
          .catch(err => {})

        },
           getRowKeyOfTarget(row) {
            return row.id
            },
            // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
           // 获取题目分类
        getClass(){
             getQuestionClass({
                name:'',
                businessId:this.businessInfo.id,
                size:1000,
                current:1,
             },'enterprise')
            .then(res => {
              this.options = res.data.records
            })
            .catch(err => {
            })
        },
    },
}
</script>
<style lang="scss" scoped>
      .public-de{
        color: #333;
        cursor: pointer;
        margin-right: 20px;
        span{
            font-size: 22px;
            
        }
        p{
                    padding-left: 5px;
        }
    }
    .public-de:hover{
        color: #155bd4;
    }
    .staff_manage_head{
        height: auto !important;
        line-height: 1.2 !important;
        padding: 20px 40px !important;
        .p-tit-c{
            padding:0 !important;
            background: #fff;
        }
    }
    .forminfo{
     .btn{
    width: 100px;
    height: 40px;
    background-color: #409eff;
    border-radius: 5px;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
     }
}
::v-deep{
  .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>